import moment from "moment";
import _ from "lodash";

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const createPipelineForSingleArg = (...functions) => target =>
    functions.reduce((sum, func) => func(sum), target);


export const hasInValidObject = (obj) => {
    if (!obj) {
        return true;
    }
    else if (obj === null) {
        return true;
    }
    else if (!obj.success) {
        return true
    }
    else if (!obj.receiveObj) {
        return true
    }
    else if (!obj.success) {
        return true;
    }

    return false;
}

export const isNullOrWhiteSpace = (str) => {
    return (!str || /^\s*$/.test(str));
};

export const getLocalDateFromUtcWithFormat = (date, format) => {
    if (!isNullOrWhiteSpace(date)) {
        return moment(moment.utc(date).toDate()).format(format);
    }
    return "";
};

export const formatSsn = (input) => {
    let ssnDigits = input.toString().replace(/\D/g, "");
    if (ssnDigits.length === 9) {
        return ssnDigits.substr(0, 3) + '-' + ssnDigits.substr(3, 2) + '-' + ssnDigits.substr(5, 4);
    }
    if (ssnDigits.length === 4) {
        return '***-**-' + ssnDigits;
    }
    return input;
}

export const dateFormatGenric = (date, format) => {
    if (!isNullOrWhiteSpace(date)) {
        return moment(date).format(format);
    }
    return "";
};

export const formatPhone = (input) => {
    if (input !== null) {
        var phoneDigits = input.toString().replace(/\D/g, "");
        if (phoneDigits.length === 10) {
            return phoneDigits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
    }
    return input;
}

export const getErrorCss = (meta) => {
    if (meta.submitFailed && meta.error) {
        return "has-validation-custom fail"
    }
    else {
        return "";
    }
}

export const transFormValueText = (input, list, valueField, returnField) => {
    if (list && list.length > 0) {
        const result = list.filter((item) => item[valueField] === input);
        if (result && result.length > 0) {
            return result[0][returnField];
        }
    }
    return "";
}


export const timeFromNow = (input) => {

    if (isNullOrWhiteSpace(input)) {
        return "";
    }

    return moment.utc(input).fromNow();
}

export const calculateTotalPaymentAmount = (balance, interest, interestDuePerMonth, minPayment) => {
    let interestRate = interest / 1200;
    if (minPayment < interestDuePerMonth) {
        minPayment = interestDuePerMonth;
    }
    let totalPayments = 0;

    let count = 0;
    while (balance > 0) {
        var currentInterest = balance * interestRate;
        balance += currentInterest;
        if (minPayment > balance) {
            minPayment = balance;
        }

        totalPayments += minPayment;
        balance -= minPayment;
        count = count + 1;
    }
    let obj = {
        totalPayments: totalPayments,
        months: count
    }

    return obj;
}

export const getCurrencyFormat = (value) => {
    if (isNullOrWhiteSpace(value)) {
        return "";
    }
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(value)
}


export const formatAccountNumber = (input) => {

    if (isNullOrWhiteSpace(input)) {
        return "";
    }
    else {
        var matches = input.match(/\d{16}/g);
        if (matches && matches[0]) {
            return input.substring(0, 4)
                + ' ' + input.substring(4, 8)
                + ' ' + input.substring(8, 12)
                + ' ' + input.substring(12, 16);
        } else {
            matches = input.match(/\d{15}/g);
            if (matches && matches[0]) {
                return input.substring(0, 4)
                    + ' ' + input.substring(4, 10)
                    + ' ' + input.substring(10, 15);
            } else {
                return input;
            }
        }
    }
}

export const getContentTypeFromFileName = function (fileName) {
    var extension = fileName.substr((~-fileName.lastIndexOf(".") >>> 0) + 2);
    switch (extension.toLowerCase()) {
        case 'gif':
            return 'image/gif';
        case 'jpg':
            return 'image/pjpeg';
        case 'jpeg':
            return 'image/jpeg';
        case 'png':
            return 'image/png';
        case 'txt':
            return 'text/plain';
        case 'htm':
        case 'html':
            return 'text/html';
        case 'doc':
            return 'application/msword';
        case 'dotx':
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.template';
        case 'docx':
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        case 'xls':
            return 'application/vnd.ms-excel';
        case 'xlsx':
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        case 'zip':
            return 'application/zip, application/x-compressed-zip';
        case 'wav':
            return 'audio/wav';
        case 'gsm':
            return 'audio/x-gsm';
        case 'csv':
            return 'application/vnd.ms-excel';
        case 'mp3':
            return 'audio/mp3';
        case 'mp4':
            return 'audio/mp4';
        default:
            return 'application/pdf';
    }
};

export const removeHTMLtags = (value) => {
    /*
        This line is optional, it replaces escaped brackets with real ones,
        i.e. &lt; is replaced with < and &gt; is replaced with >
    */
    value = value.replace(/&(lt|gt);/g, function (strMatch, p1) {
        return (p1 === "lt") ? "<" : ">";
    });

    let tagStrippedText = value.replace(/<\/?[^>]+(>|$)/g, "");
    return tagStrippedText;
};

export const arrayArrayHorizontally = (arr, lengthofsublist) => {
    if (arr && arr.length > 0) {
        let arrayToReturn = [];

        let subArray = [];
        let pushed = true;

        for (let i = 0; i < arr.length; i++) {
            if ((i + 1) % lengthofsublist === 0) {
                subArray.push(arr[i]);

                arrayToReturn.push(subArray);
                subArray = [];
                pushed = true;
            } else {
                subArray.push(arr[i]);
                pushed = false;
            }
        }
        if (!pushed) {
            arrayToReturn.push(subArray);
        }
        return arrayToReturn;
    }

    return arr;
};

export const tryParseFloat = (str, defaultValue) => {

    let retValue = defaultValue;
    if (!isNullOrWhiteSpace(str)) {
        if (!isNaN(str)) {
            retValue = parseFloat(str);
        }
    }
    return retValue;
}

export const tryParseInt = (str, defaultValue) => {

    let retValue = defaultValue;
    if (!isNullOrWhiteSpace(str)) {
        if (!isNaN(str)) {
            retValue = parseInt(str);
        }
    }
    return retValue;
}

export const roleName = () => {

    let role = {
        Administrator: 'administrator',
        SalesRep: 'salesrepresentative',
        CustomerRep: 'customerrepresentative',
        Affiliate: 'affiliate',
        AffiliateSales: 'affiliatesales',
        CustomerAdministrator: 'customeradministrator',
        SalesAdministrator: 'salesadministrator',
        Negotiator: 'negotiator',
        NegotiatorSupervisor: 'negotiatorsupervisor',
        CustomerRepSupervisor: 'customerrepsupervisor',
        SalesRepSupervisor: 'salesrepsupervisor',
        AffiliateReports: 'affiliatereports',
        AffiliateAdmin: 'affiliateadmin',
        AffiliateMailingSearch: 'affiliatemailingsearch',
        LoanServicer: 'loanservicer',
        Attorney: 'attorney',
        LiveUnderwritingsales: 'liveunderwritingsales',
        LiveUnderwritingSalesSupervisor: 'liveunderwritingsalessupervisor',
        AffiliateLead: 'affiliatelead'
    };

    return role;
};


export const hasErrorCss = (show) => {
    if (show) {
        return "has-validation-custom fail"
    }
    else {
        return "";
    }
}

export const splitCamelCase = (input) => {

    if (typeof input !== "string") {
        return input;
    }

    return input.split(/(?=[A-Z])/).join(' ');

}

export const customerAdminRoleFound = function (userDetail) {
    let isManageOverRideRole = false;
    if (userDetail) {
        if (userDetail.role) {

            let role = userDetail.role.toLowerCase() === roleName().CustomerAdministrator.toLowerCase();

            if (role) {
                isManageOverRideRole = true;
            }

        }
    }
    return isManageOverRideRole;
};

export const filterFeeTypes = (input) => {

    let description = "";

    switch (input) {
        case 'RepaymentFees':
            {
                description = "Repayment Amount";
                break;
            }
        case 'ServiceFee':
            {
                description = "Service Fees";
                break;
            }
        case 'CreditDNA':
            {
                description = "Credit DNA (Optional)";
                break;
            }
        case 'ScoreNavigator':
            {
                description = "Score Navigator";
                break;
            }
        case 'SettlementPercent':
            {
                description = "Loan Settlement (%)";
                break;
            }
        case 'NonSettlementFees':
            {
                description = "Fees";
                break;
            }
        case 'AttorneyFee':
            {
                description = "Attorney Fee";
                break;
            }
        case 'AdminFee':
            {
                description = "Administration Fee";
                break;
            }
        default:
            {
                description = input;
                break;
            }
    }
    return description;

}



export const checkSupervisorFound = function (userDetail) {
    let isFound = false;
    if (userDetail) {
        if (userDetail.role) {
            let item = userDetail.role;
            isFound = (item.toLowerCase() === roleName().CustomerRepSupervisor.toLowerCase() || item.toLowerCase() === roleName().NegotiatorSupervisor.toLowerCase() ||
                item.toLowerCase() === roleName().SalesRepSupervisor.toLowerCase());
        }
    }
    return isFound;
};

export const checkRoleFound = (userDetail, role) => {
    let isFound = false;
    if (userDetail) {
        if (userDetail.role) {
            let item = userDetail.role
            isFound = (item.toLowerCase() === role.toLowerCase());

        }
    }

    return isFound;
};

export const filterPaymentMethod = (input) => {

    if (input === 1) {
        return "Money Gram";
    } else if (input === 2) {
        return "ACH";
    } else {
        return "Not Set";
    }
}

export const sum = (array, key) => {
    if (!Array.isArray(array) || !key) {
        return null;
    }
    return array.reduce((a, b) => a + (b[key] || 0), 0);
}

// Current getCurrencyFormat is not working with 0 value.
export const currencyFormat = (value) => new Intl.NumberFormat("en-US",
    {
        style: "currency",
        currency: "USD"
    }).format(value);

export const getStatus = (permissionDetail, contractStatus) => {
    let statusMenu = [];

    if (permissionDetail != null && permissionDetail.userAccess && permissionDetail.userAccess.status_overrides) {
        let result = contractStatus.filter((a) => {
            return _.find(permissionDetail.userAccess.status_overrides, (b) => {
                return b === a.id;
            });
        })

        for (let i = 0; i <= result.length - 1; i++) {
            let obj = undefined;
            obj = {
                id: result[i].id,
                name: isNullOrWhiteSpace(result[i].action) ? result[i].name : result[i].action
            };

            if (obj) {
                statusMenu.push(obj);
            }
        }
    }

    return statusMenu;
};

export const getStatusText = () => {
    return {
        open: "Open",
        contractGenerated: "ContractGenerated",
        working: "Working",
        status: "configured_status",
        statusUrl: "status",
        filterlistUrl: "filterlist"
    };
};

export const hasConfigureNotification = (obj) => {

    if (!obj) {
        return true;
    }
    else if (!obj == null) {
        return true;
    }
    else if (!obj.success) {
        return true
    }
    else if (!obj.receiveObj) {
        return true
    }
    else if (!obj.success) {
        return true;
    }

    return false;
}


export const dispositionStatus = () => {
    let retValue = [{ id: 1, value: "Scheduled" },
    { id: 2, value: "No Show" },
    { id: 3, value: "Missed" },
    { id: 4, value: "Rescheduled" },
    { id: 5, value: "Complete" },
    { id: 7, value: "NotSet" }];
    return retValue;
}

export const salesRoleFound = (userDetail) => {
    let isFound = false;
    if (userDetail) {
        if (userDetail.role) {
            let role = (userDetail.role.toLowerCase() === roleName().SalesRep.toLowerCase() || userDetail.role.toLowerCase() === roleName().AffiliateSales.toLowerCase()
                || userDetail.role.toLowerCase() === roleName().AffiliateLead.toLowerCase()
                || userDetail.role.toLowerCase() === roleName().LiveUnderwritingsales.toLowerCase());

            if (role) {
                isFound = true;
            }

        }
    }
    return isFound;
};

export const searchQueryParm = (location, key) => {
    const url = new URLSearchParams(location);
    return url.get(key);
}

export const passwordGenerator = () => {
    let factory = {};
    factory._pattern = /[a-zA-Z0-9_]/;
    factory._getRandomByte = function () {
        // http://caniuse.com/#feat=getrandomvalues
        if (window.crypto && window.crypto.getRandomValues) {
            let result = new Uint8Array(1);
            window.crypto.getRandomValues(result);
            return result[0];
        }
        else if (window.msCrypto && window.msCrypto.getRandomValues) {
            let result = new Uint8Array(1);
            window.msCrypto.getRandomValues(result);
            return result[0];
        }
        else {
            return Math.floor(Math.random() * 256);
        }
    }

    factory.generate = function (length) {
        return Array.apply(null, { 'length': length })
            .map(function () {
                let result;
                while (true) {
                    result = String.fromCharCode(factory._getRandomByte());
                    if (factory._pattern.test(result)) {
                        return result;
                    }
                }
            }, this).join('');
    }

    return factory;
}

export const removeLastChar = (s, lengthCheck) => {
    if (isNullOrWhiteSpace(s)) {
        return "";
    }

    if (s.length > lengthCheck) {
        return s.substring(0, s.length - 1);
    }
    return s;
}

export const salesRepRoleFound = (userDetail) => {
    let isFound = false;
    if (userDetail) {
        if (userDetail.role) {
            let role = (userDetail.role.toLowerCase() === roleName().SalesRep.toLowerCase() || userDetail.role.toLowerCase() === roleName().AffiliateSales.toLowerCase()
                || userDetail.role.toLowerCase() === roleName().AffiliateLead.toLowerCase()
                || userDetail.role.toLowerCase() === roleName().LiveUnderwritingsales.toLowerCase()
                || userDetail.role.toLowerCase() === roleName().LiveUnderwritingSalesSupervisor.toLowerCase());

            if (role) {
                isFound = true;
            }

        }
    }
    return isFound;
};

export const isDmDetail = (detail, configured_status) => {
    let isDmNot = false;
    const clientStatus = configured_status.filter(a => a.id === detail.status)[0];

    if (clientStatus.name !== 'Imported To DM') {
        isDmNot = true;
    }

    //after migration DM use this code

    // if (clientStatus !== null && (clientStatus.is_signed === false || clientStatus.name === 'Contract Signed')) {
    //     isDmNot = true;
    // }
    return isDmNot;
};

export const noOfDayMonthDiff = (d1, d2) =>{
    let months = moment(d2).diff(moment(d1), 'months', true);
    return Math.ceil(months)
};

export const getNoOfMonth = function (data) {
    let totalMonths = 0, tempMonths = {}
    _.forEach(data, (item) => {
        if (item.status != 6) {
            var monthYear = moment(item.date).format('MM/yyyy');
            if (!tempMonths[monthYear]) {
                tempMonths[monthYear] = true;
                totalMonths += 1;
            }
        }
    });

    return totalMonths;
};

export const getLastIndexValueFromArray = (array) => {
    return array[array.length - 1];
}